// extracted by mini-css-extract-plugin
export default {"centered":"TableProductsProvidersBody_centered__uHIJW","message":"TableProductsProvidersBody_message__ncmrk"};